

export const ExcelMapping: Record<string, string> = {

    //Personal Detials

    "State of residence (last 10 years)": "state_of_residence",
    "Residence during (first 10 years)": "residence_during_childhood",
    "Lives In": "lives_in",
    "Marital Status": "marital_status",
    "Religion": "religion",
    "Ethnicity": "ethnicity",

    "Adults (>18 yrs age)": "no_of_adults_family_member",
    "Children (<18 yrs age)": "no_of_child_family_member?tyoe",
    "Patient Education": "patient_education",
    "Patient Occupation": "patient_occupation",

    "Education": "kuppuswamy_scale_education_of_the_head",
    "Occupation of the Head of family": "kuppuswamy_scale_occupation_of_the_head",
    "Updated Monthly Family Income in Rs.": "kuppuswamy_scale_updated_monthly_family_income",
    "Vehicle": "vehicle",
    "Recruitment Method": "recruitment_method",
    "Water Source": "water_source",

    "H. pylori ELISA Status": "h_pylori_elisa",
    "H. pylori ELISA Why not done": "h_pylori_elisa_why_not_done",
    "H. pylori ELISA Value": "h_pylori_elisa_value",
    "H. pylori ELISA Result": "h_pylori_elisa_result",
    "S. typhi ELISA Status": "s_typhi_elisa",
    "S. typhi ELISA Why not done": "s_typhi_elisa_why_not_done",
    "S. typhi ELISA Value": "s_typhi_elisa_value",
    "S. typhi ELISA Result": "s_typhi_elisa_result",

    "Name of the tertiary care hospital": "nearest_health_care_center.name_of_the_tertiary_care_hospital",
    "Ultrasonology place": "nearest_health_care_center.ultrasonology_place",
    "Surgery place": "nearest_health_care_center.surgery_place",

    "Menarche (Age)": "reproductive_h_per_o.menarche",
    "Menopause (Age)": "reproductive_h_per_o.menopause",
    "Regular": "reproductive_h_per_o.regular",
    "Age At Marriage": "reproductive_h_per_o.age_at_marriage",
    "Age at first child birth (years)": "reproductive_h_per_o.age_at_first_child_birth",
    "Age at last child birth (years)": "reproductive_h_per_o.age_at_last_child_birth",
    "Total no. of Children": "reproductive_h_per_o.total_no_of_children",
    "Total no. of Abortions": "reproductive_h_per_o.total_no_of_abortions",
    "Breast feed (Cumulative breast feeding months)": "reproductive_h_per_o.breast_feed_months",
    "Gynaecological surgery": "reproductive_h_per_o.gynaecological_surgery",
    "Which Surgery": "reproductive_h_per_o.which_surgery",
    "Age at which surgery done": "reproductive_h_per_o.age_at_which_surgery_done",

    "Height (cm)": "anthropometric_measurement.height_cm",
    "Weight (kg)": "anthropometric_measurement.weight_kg",
    "Waist Circumference (cm)": "anthropometric_measurement.waist_circumference",
    "Hip Circumference (cm / inch)": "anthropometric_measurement.hip_circumference_cm",
    "BMI (kg/m²)": "anthropometric_measurement.bmi_kg_per_m_square",
    "Blood Pressure (mmHg)": "anthropometric_measurement.blood_pressure",
    "W/H Ratio": "anthropometric_measurement.weight_height_ratio_kg_m_sqaure",
    "Mid Arm Circumference (cm)": "anthropometric_measurement.mid_arm_circumference_cm",
    "Tooth Count": "anthropometric_measurement.tooth_count",

    "Duration of Pregnency": "pregnancies_history.duration_of_pregnancy",
    "How Did The Pregnency End": "pregnancies_history.how_did_the_pregnancy_end",
    "Type of Delivery": "pregnancies_history.type_of_delivery",
    "Complications": "pregnancies_history.complications",

    // Clinical History

    "Comorbidities": "comororbidities",
    "Drug Name": "drug_history.drug_name",
    "NFC Status": "drug_history.nfc_status",
    "Typhoid History": "typhoid.typhoid_history",
    "Typhoid How many years back": "typhoid.how_many_years_back",
    "Typhoid Bases of Diagnosis": "typhoid.bases_of_diagnosis",
    "Typhoid Treatment Received": "typhoid.treatment_received",

    "Smoking": "smoking.nfc_status",
    "Smoking Duration (years)": "smoking.duration_years",
    "Smoking Amount per Day (sticks / gram)": "smoking.amount_per_day",
    "Smoking Type of Smoking": "smoking.type_of_smoking",

    "Alcohol": "alcohol.nfc_status",
    "Alcohol Duration (years)": "alcohol.duration_years",
    "Alcohol Amount per Day (ml)": "alcohol.amount_per_day",
    "Alcohol No. of times a week": "alcohol.times_per_week",
    "Alcohol Type": "alcohol.alcohol_type",

    "Exposure to Industry": "exposure_to_industry",

    "Pesticide NFC Status": "pesticide_use.nfc_status",
    "Pesticide For How Long (Years)": "pesticide_use.for_how_long",
    "Pesticide Which One": "pesticide_use.which_one",
    "Pesticide Personal protective gear used": "pesticide_use.personal_protective_gear_used",

    "Total no. of Brothers": "no_of_brothers",
    "Total no. of Sisters": "no_of_sisters",
    "Total no. of Sons": "no_of_sons",
    "Total no. of Daughters": "no_of_daughters",

    "Family History First degree relative": "family_history.first_degree_relative",
    "Family History Age": "family_history.at_what_age",
    "Family History Complication": "family_history.complication",
    "Family History Symptomatic / Asymptomatic": "family_history.is_symptomatic",
    "Family History Was Surgery done": "family_history.was_surgery_done",

    "Family history of GBC": "is_family_history_of_gbc",
    "Family history of Liver Cancer": "is_family_history_of_liver_cancer",
    "Family history of Liver Cirrhosis": "is_family_history_of_liver_cirrhosis",


    //Dietary Determinants

    "Diet": "diet.diet",
    "Diet Quantity": "diet.quantity",
    "Diet Type of Food": "diet.type_of_food",
    "Diet Frequency": "diet.frequency",
    "Staple Diet": "staple_diet",
    "Use of repeatedly heated oil": "use_of_repeatedly_heated_oil",
    "Food Storage": "food_storage",
    "Source of food": "source_of_food",
    "Weekly Food consumption name": "weekly_food_consumption.name",
    "Weekly Food consumption no of times a week": "weekly_food_consumption.no_of_times_a_week",
    "Type of fat Name": "type_of_fats.name",
    "Type of fat Quantity (ml/month)": "type_of_fats.quantity_ml_per_month",
    "Types Name": "types.label",
    "Source": "types.source",
    "Is Packed": "types.is_packed",


    "Food Red Chili NFC Status": "food_red_chili.n_f_c",
    "Food Red Chili Is Regular": "food_red_chili.is_regular",
    "Food Red Chili Type of Food": "food_red_chili.type_of_food",
    "Food Green Chili NFC Status": "food_green_chili.n_f_c",
    "Food Green Chili Is Regular": "food_green_chili.is_regular",
    "Food Green Chili Type of Food": "food_green_chili.type_of_food",
    "Food Peanuts NFC Status": "food_peanuts.n_f_c",
    "Food Peanuts Is Regular": "food_peanuts.is_regular",
    "Food Peanuts Type of Food": "food_peanuts.type_of_food",
    "Food Coffee NFC Status": "food_coffee.n_f_c",
    "Food Coffee Is Regular": "food_coffee.is_regular",
    "Food Coffee Type of Food": "food_coffee.type_of_food",
    "Food Tea NFC Status": "food_tea.n_f_c",
    "Food Tea Is Regular": "food_tea.is_regular",
    "Food Tea Type of Food": "food_tea.type_of_food",


    // Gall Stone
    "Which year was GS first detected (Years)": "gs_first_detected",
    "Duration of stones (months)": "duration_of_stone",
    "Symptom Duration": "duration_of_symptoms",
    "How was it detected": "how_was_it_detected",
    "How was it detected Remarks": "how_was_it_detected_remarks",
    "Frequency of symptoms per month": "frequency_of_symptoms_per_month",
    "Was Surgery advised": "when_was_surgey_advised",
    "Was surgery Done": "why_not_done_surgery",
    "Nausea": "nausea",
    "Vomiting": "vomiting",

    "Documented on": "documented_on",
    "Symptom status": "symptom_status",

    "Type of pain": "type_of_pain",
    "Type of pain Remarks": "type_of_pain_remarks",
    "Pain description onset": "pain_description",
    "Pain intensity": "intensity",
    "Pain radiation": "radiation",
    "Pain location": "location",
    "Pain precipitated by": "precipitated_by",
    "Pain duration": "duration",

    "Pain at Night": "pain_at_night",
    "Pain at Exertion": "pain_at_exertion",

    "Relief of pain achieved by": "relief_of_pain",

    "Is hospitalization required": "is_require_hospitalization",
    "Total no. of hospitalizations": "total_no_of_hospitalizations",

    "Associated symptoms": "associated_symptoms",

    "Gallstone status": "gallstone_status",
    "Description of symptoms": "description_of_symptoms",

    "Date of test": "date_of_test",
    "Severity": "severity",

    "Frequency (raw text)": "frequency",
    "Frequency times/day": "frequency",
    "Frequency times/week": "frequency",
    "Frequency times/month": "frequency",
    "Frequency times/year": "frequency",

    "Stool frequency": "stool_frequency",
    "Bristol stool usual score": "bristol_stool_usual_score",
    "Bristol stool worst score": "bristol_stool_worst_score",

    "Dyspepsia final score": "dyspepsia_final_score",
    "Symptoms of dyspepsia": "symptoms_of_dyspepsia",
    "Dyspepsia scoring index": "dyspepsia_scoring_index",

    "When was surgery advised": "when_was_surgey_advised",
    "Why surgery not done": "why_not_done_surgery",

    //Dyspepsia Symptoms

    "Symptoms of Dyspepsia Name": "symptoms_of_dyspepsia.symptoms_name",
    "Symptoms of Dyspepsia Remarks": "symptoms_of_dyspepsia.remarks",
    "Dyspepsia Scoring Index": "dyspepsia_scoring_index.dyspepsia_name",
    "Dyspepsia Scoring Index Score": "dyspepsia_scoring_index.score",
    "Stool frequency (Per week)": "stool_frequency",
    "Usual Score": "bristol_stool_usual_score",
    "Worst Score": "bristol_stool_worst_score",

    //GBC clinical presentation
    "Pain": '"pain_x_value',
    "Pain Description": "pain_desc",
    "Jaundice": "jaundice_x_value",
    "Jaundice Description": "jaundice_desc",
    "Pruritis": "pruritis_x_value",
    "Pruritis Description": "pruritis_desc",
    "Fever": "fever_x_value",
    "Fever Description": "fever_desc",
    "Cholangitis": "cholangitis_x_value",
    "Cholangitis Description": "cholangitis_desc",
    "Abd. Distension": "abd_distension_x_value",
    "Abd. Distension Description": "abd_distension_desc",
    "Features of G.O.O.": "features_of_goo_x_value",
    "Features of G.O.O. Description": "features_of_goo_desc",
    "Anorexia": "anorexia_x_value",
    "Anorexia Description": "anorexia_desc",
    "H/o Lump": "ho_lump_x_value",
    "H/o Lump Description": "ho_lump_desc",
    "Wt. Loss": "wt_loss_x_value",
    "Wt. Loss Description": "wt_loss_desc",
    "Past history of GSD": "past_history_of_gsd_x_value",
    "Past history of GSD Description": "past_history_of_gsd_desc",
    "Duration of GSD": "duration_of_gsd_x_value",
    "Duration of GSD Description": "duration_of_gsd_desc",
    "GB Lump (size)": "gb_lump_size_x_value",
    "GB Lump (size) Description": "gb_lump_size_desc",
    "Hepatomegaly": "hepatomegaly_x_value",
    "Hepatomegaly Description": "hepatomegaly_desc",
    "Post cholecystectomy scar": "post_cholecystectomy_scar_x_value",
    "Post cholecystectomy scar Description": "post_cholecystectomy_scar_desc",
    "Supraclavicular LN (size, Rt /Lt)": "supraclavicular_ln_x_value",
    "Supraclavicular LN (size, Rt /Lt) Description": "supraclavicular_ln_desc",
    "Ascites": "ascites_x_value",
    "Ascites Description": "ascites_desc",
    "Tenderness": "tenderness_x_value",
    "Tenderness Description": "tenderness_desc",

    //Clinical Examination
    "ECOG Performance Status": "clinical_examination_ecog_performance_status",

    // Quality of Life
    "Mobility": "mobility",
    "Self Care": "self_care",
    "Usual Activities": "usual_activity",
    "Pain/Discomfort": "pain_description",
    "Anxiety": "anxiety_depression",
    "Health Scale": "health_scale",

    // Investigations
    "Hemoglobin (g/dl)": "haematology.hemoglobin",
    "Total Leukocyte Count (/mm³)": "haematology.total_leukocyte_count",
    "Differential Leukocyte Count": "dlc",
    "Platelet Count (*10³,10⁶/mm³)": "platelet_count",
    "otal Bilirubin (mg/dL)": "liver_function_test.total_bilirubin",
    "Conjugated Bilirubin (mg/dL)": "liver_function_test.conjugated_bilirubin",
    "SGOT (AST, units/L)": "liver_function_test.sgot_ast",
    "SGPT (ALT, units/L)": "liver_function_test.sgpt_alt",
    "S.Alkaline Phosphatase (ALP, units/L)": "liver_function_test.s_alkaline_phosphatase",
    "Total Proteins (g/dl)": "Total Proteins (g/dl).total_proteins",
    "Albumin (g/dl)": "biochemistry.albumin",
    "Sodium (mMol/L)": "biochemistry.sodium",
    "Potassium (mMol/L)": "biochemistry.potassium",
    "B. Urea (mMol/L)": " biochemistry.b_urea",
    "S. Creatinine (mg/dL": "biochemistry.s_creatinine",
    "Fasting Blood Sugar (mg/dL)": "biochemistry.fasting_blood_sugar",
    "HbA1c": "biochemistry.hba1c",
    "Cholesterol (mg/dL)": "biochemistry.cholesterol",
    "Triglyceride (mg/dL)": "biochemistry.triglyceride",
    "LDL (mg/dL)": "biochemistry.ldl",
    "HDL (mg/dL)": "biochemistry.hdl",
    "VLDL (mg/dL)": "biochemistry.vldl",
    "Calcium (mg/dL)": "biochemistry.calcium",
    "Phosphorous (mg/dL)": "biochemistry.phosphorous",
    "Magnesium (mg/dL)": "biochemistry.magnesium",
    "Vitamin D (nmol/L)": "biochemistry.vitamin_d",
    "Date - Time": "date_time",

    //Radiology

    "Date of Radiology": "date",
    "USG Done By": "usg_done_by",
    "Outside study centre Name": "out_side_study_center",
    "Fasting": "fasting",
    "Gallbladder": "gallbladder",
    "Sludge": "sludge",
    "GB polyp": "gb_polyp",
    "Stone": "stone",
    "Number of stones": "number_of_stones",
    "Size of largest stones(mm)": "size_of_stones",
    "Fundus (mm)": "gb_wall_fundus",
    "Thickened": "gb_wall_thickened",
    "Normal or Thickened": "gb_wall_normal_or_thickened",
    "Symmetrical": "gb_wall_symmetrical",
    "Layered appearance": "gb_wall_layered_appearance",
    "Intramural cyst": "gb_wall_intramural_cyst",
    "Intramural echogenic foci": "gb_wall_intramural_echogenic_foci",
    "GB interface with liver": "gb_interface_with_liver",
    "Fatty Liver": "fatty_liver",
    "Any complications": "any_complications",
    "Standard meal for GBEF": "why_gbef_not_done",

    "Gallbladder Ejection fraction type": "gallbladder_ejection_fraction.type",
    "Gallbladder Ejection fraction Time": "gallbladder_ejection_fraction.time",
    "Gallbladder Ejection fraction GB length (cm)": "gallbladder_ejection_fraction.gb_length",
    "Gallbladder Ejection fraction GB breadth (cm)": "gallbladder_ejection_fraction.gb_breadth",
    "Gallbladder Ejection fraction GB height (cm)": "gallbladder_ejection_fraction.gb_height",
    "Gallbladder Ejection fraction Means GB volume": "gallbladder_ejection_fraction.gallbladder_ejection_fraction",
    "Gallbladder Ejection fraction Timing": "gallbladder_ejection_fraction.postprandial_timing",

    //Surgery

    "Date of Surgery": "date",
    "Surgery done by": "surgery_done_by",
    "Outside study center name": "outside_study_center_name",
    "Type of Surgery": "type_of_surgery",
    "Intra-operative Findings": "intraoperative_findings",
    "Gall bladder": "gall_bladder",
    "Gall bladder distension": "gall_bladder_distension",
    "Any anatomical variation": "any_anatomical_variation",
    "Cut section": "cut_section",
    "Bile spillage": 'bile_spillage',
    "Duration of procedure": "duration_of_procedure",
    "Surgery Complications": "complications",

    //Histology

    "Histology Date": "date_time",
    "Ref-Number": "ref_number",
    "Length of GB (cm)": "length_of_gb_cm",
    "Wall thickness (range in mm)": "wall_thickness",
    "Fundus": "fundus",
    "Body": "body",
    "Neck": "neck",
    "Growth/polyp/ulcer": "growth_polyp_ulcer",
    "Inflammation": "inflammation",
    "Type of inflammation N": "type_inflammation_n",
    "Type of inflammation L": "type_inflammation_l",
    "Type of inflammation M": "type_inflammation_m",
    "Type of inflammation E": "type_inflammation_e",
    "Type of inflammation PC": "type_inflammation_pc",
    "Depth of inflammation": "pattern_of_inflammation",
    "Pattern of inflammation": "pattern_of_inflammation",
    "Granuloma": "granuloma",
    "Giant cells": "giant_cells",
    "Reactive lymphoid follicles": "reactive_lymphoid_follicles",
    "Mucosal denudation": "mucosal_denudation",
    "Mucosal ulceration": "mucosal_ulceration",
    "Mucosal hyperplasia": "mucosal_hyperplasia",
    "Fibrosis": "fibrosis",
    "Muscle hypertrophy": "muscle_hypertrophy",
    "Myocyte vacuolation": "myocyte_vacuolation",
    "RAS": "ras",
    "Hyalinisation": "hyalinisation",
    "Calcification": "calcification",
    "Metaplasia (AB-PAS stain)": "metaplasia",
    "Dysplasia": "dysplasia",
    "Atypia NOS": "atypia_nos",
    "Cholecystitis": "cholecystitis",
    "Incidental GBC": "incidental_gbc",
    "Invasive Carcinoma": "invasive_carcinoma",
    "Any additional findings (not listed above)": "any_additional_findings",

    //Stone Analysis
    "Stone Analysis Date": "date_time",
    "Number of Stones": "number_of_stones",
    "Size of Stones (mm / cm / inch)": "size_of_stones",
    "Shape of Stones": "shape_of_stones",
    "Weight of stone": "weight_of_stone",
    "Total Volume": "total_volume",
    "FTIR": "ftir",
    "Stone C/S": "stone_cs",
    "Cholesterol composition": "cholesterol_composition",

    //Cost effective analysis

    "Expenditure (OPD) Date": "opd_visit.date",
    "OPD Travelling cost": "opd_visit.travelling_cost",
    "OPD Distance (km)": "opd_visit.distance",
    "OPD Vehicle": "opd_visit.vehicle",
    "OPD Medicines": "opd_visit.medicines",
    "OPD Lab tests/ Diagnostics": "opd_visit.lab_tests_diagnostics",
    "OPD Procedure/Surgery": "opd_visit.procedure_surgery",
    "OPD User fees/Hospital charges (including bed charges, diagnostics etc.)": "opd_visit.user_fees",
    "OPD Informal payment": "opd_visit.informal_payment",
    "OPD Boarding/Lodging/Food": "opd_visit.boarding_lodging_food",
    "OPD Other(1) ": "opd_visit.other1",
    "OPD Other(2)": "opd_visit.other2",
    "OPD Other(3)": "opd_visit.other3",
    "Expenditure (IPD) Date": "ipd_visit.date",
    "IPD Travelling cost": "ipd_visit.travelling_cost",
    "IPD Distance (km)": "ipd_visit.distance",
    "IPD Vehicle": "ipd_visit.vehicle",
    "IPD Medicines": "ipd_visit.medicines",
    "IPD Lab tests/ Diagnostics": "ipd_visit.lab_tests_diagnostics",
    "IPD Procedure/Surgery": "ipd_visit.procedure_surgery",
    "IPD User fees/Hospital charges (including bed charges, diagnostics etc.)": "ipd_visit.user_fees",
    "IPD Informal payment": "ipd_visit.informal_payment",
    "IPD Boarding/Lodging/Food": "ipd_visit.boarding_lodging_food",
    "IPD Other(1) ": "ipd_visit.other1",
    "IPD Other(2)": "ipd_visit.other2",
    "IPD Other(3)": "ipd_visit.other3",


}


